import React from "react";

const IconEdit = ({ styleClass = "text-blue-2" }) => {
	return <i className={`fa-solid fa-pen text-base ${styleClass}`}></i>;
};

export default IconEdit;
